export default __webpack_public_path__ + "static/media/Marketing.ce397807.svg";